import { takeEvery, call, put } from 'redux-saga/effects';
import {
  dataRequest,
  requestFinished,
  insertUpdateItems as insertUpdateObjectCollectionItems
} from '../../../../../../common/reducers/objectCollection/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import ContestsService from '../../../../services/ContestsService';

function* contestsCollectionSaga(reducerName, action) {
  let status = null;
  try {
    const result = yield call(
      timeoutCall,
      ContestsService.getContestById,
      action.payload.objectId
    );
    if (result.response) {
      status = result.response.status;
      if (result.response.status) {
        yield put(
          insertUpdateObjectCollectionItems(reducerName, result.destructData)
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, action.payload.objectId, status));
}

export default function createSaga(reducerName) {
  return [
    takeEvery(
      dataRequest(reducerName).type,
      contestsCollectionSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/contests/reducers/static/collections/sagas/contestsCollectionSaga.js